<template>
  <path
    d="M11.13 4.57018L2.83 19.5102C2.46 20.1802 2.94 21.0002 3.7 21.0002H20.3C21.06 21.0002 21.54 20.1802 21.17 19.5102L12.87 4.57018C12.49 3.89018 11.51 3.89018 11.13 4.57018ZM13 8.92018L18.6 19.0002H13V8.92018ZM11 8.92018V19.0002H5.4L11 8.92018Z"
  />
</template>
